import { NgModule } from '@angular/core';
import { MODULES, WIDGET_DEFINITION, WIZARD_DEFINITION, WIZARD_STEP_CONTROLLER } from './product.config';
import {WidgetRegistryService, WizardRegistryService, NotificationService, WidgetDefinition, WizardDefinition} from '@sdbn/appclient';

@NgModule({
  exports: [
    MODULES

  ],
  imports: [

  ]
})
export class ProductConfigurationModule  {

  constructor(private widgetRegistryService: WidgetRegistryService,
    private wizardRegistryService: WizardRegistryService,
    private notificationService: NotificationService)
    {

      for (const definition of WIDGET_DEFINITION) {
        if (definition != null) {
          widgetRegistryService.registerWidget(new WidgetDefinition(definition));
        }
      }

      for (const controller of WIZARD_STEP_CONTROLLER) {
        if (controller != null) {
          wizardRegistryService.registerFlowStepController(controller.key, controller.controller);
        }

      }

      for (const wizardDefinition of WIZARD_DEFINITION) {
        if (wizardDefinition != null) {
          const wizard = new WizardDefinition(wizardDefinition);
          wizardRegistryService.registerWizard(wizard);
        }
      }
    }

}
